<template>
  <div class="HintComponent">
    <div class="container">
      <i
        class="icon-advertencia"
        aria-hidden="true"
      ></i>
      <h1 class="gl_form-title">{{ configurations.tags.familyDiscountHintView.label }}</h1>
      <p>{{ configurations.tags.familyDiscountHintView.text1 }}</p>
      <p>{{ configurations.tags.familyDiscountHintView.text2 }}</p>
    </div>
  </div>

  <div class="actions">
    <BaseButton
      type="primary"
      @click="handleAction(true)"
    >
      {{ configurations.tags.familyDiscountHintView.forOnlyFamilyBtn }}
    </BaseButton>

    <BaseButton
      type="outlined"
      @click="handleAction(false)"
    >
      {{ configurations.tags.familyDiscountHintView.forAllBtn }}
    </BaseButton>
  </div>
</template>
<script setup lang="ts">
  import BaseButton from '@/modules/core/components/ui/BaseButton.vue'
  import DentalConfigurations from '@/modules/dental/common/models/APP/DentalConfigurations'
  import { ref } from 'vue'

  defineProps({
    configurations: {
      type: DentalConfigurations,
      default: () => {}
    }
  })

  const emit = defineEmits(['action'])
  const onlyFamily = ref(false)

  function handleAction(value: boolean) {
    onlyFamily.value = value
    emit('action', value)
  }
</script>
<style lang="scss" scoped>
  .HintComponent {
    text-align: center;
    margin-top: $spacing-3xl;

    & > .container {
      max-width: $size-343;
      margin: 0 auto;
    }

    h1 {
      font-weight: $font-weight-700;
      margin: $spacing-3xl 0;
    }

    i {
      font-size: $font-size-80;
    }

    p {
      font-size: $font-size-l;
      color: $color-primary-dark;
      margin: $spacing-l 0;
    }

    p:last-of-type {
      margin-top: $spacing-2xl;
      margin-bottom: $spacing-3xl;
    }

    .actions {
      gap: $gap-s;
    }
  }
</style>
